import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-dbc05e44"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "Vouchers" }
const _hoisted_2 = { class: "category-volume" }
const _hoisted_3 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_van_tab = _resolveComponent("van-tab")!
  const _component_van_tabs = _resolveComponent("van-tabs")!
  const _component_VoucherItem = _resolveComponent("VoucherItem")!
  const _component_van_list = _resolveComponent("van-list")!
  const _component_voucherEmpty = _resolveComponent("voucherEmpty")!
  const _component_download_app = _resolveComponent("download-app")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Header, { title: "My Vouchers" }),
    _createVNode(_component_van_tabs, {
      active: $setup.active,
      "onUpdate:active": _cache[0] || (_cache[0] = ($event: any) => (($setup.active) = $event)),
      onClick: $setup.onClick,
      ellipsis: false,
      style: {"margin-bottom":"10px"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_tab, { title: "Valid" }),
        _createVNode(_component_van_tab, { title: "Used" }),
        _createVNode(_component_van_tab, { title: "Invaild Voucher" })
      ]),
      _: 1
    }, 8, ["active", "onClick"]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_van_list, {
        loading: $setup.loading,
        "onUpdate:loading": _cache[2] || (_cache[2] = ($event: any) => (($setup.loading) = $event)),
        finished: $setup.finished,
        "loading-text": "loading",
        onLoad: $setup.onLoad
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.voucherData.obj, (item) => {
            return (_openBlock(), _createBlock(_component_VoucherItem, {
              isShowDownload: $setup.isShowDownload,
              "onUpdate:isShowDownload": _cache[1] || (_cache[1] = ($event: any) => (($setup.isShowDownload) = $event)),
              key: item.id,
              item: item
            }, null, 8, ["isShowDownload", "item"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["loading", "finished", "onLoad"])
    ]),
    (!$setup.loading &&$setup.voucherData.obj.length == 0 )
      ? (_openBlock(), _createBlock(_component_voucherEmpty, {
          key: 0,
          content: "No coupons~"
        }))
      : _createCommentVNode("", true),
    ($setup.isShowDownload)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_component_download_app, {
            title: "This voucher need to download APP to use",
            modelValue: $setup.isShowDownload,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.isShowDownload) = $event))
          }, null, 8, ["modelValue"])
        ]))
      : _createCommentVNode("", true)
  ]))
}